import { render, staticRenderFns } from "./IconX.vue?vue&type=template&id=3a4a56da&scoped=true&"
import script from "./IconX.vue?vue&type=script&lang=js&"
export * from "./IconX.vue?vue&type=script&lang=js&"
import style0 from "./IconX.vue?vue&type=style&index=0&id=3a4a56da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4a56da",
  null
  
)

export default component.exports